import { MapPin } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const LOGO = "/assets/images/logo-banner.webp";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="py-12 bg-[#2D2926]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <img src={LOGO} alt="Paseo Chahué" className="h-10 w-auto" />
          <div className="flex items-center gap-2 text-white/70">
            <MapPin className="w-4 h-4 text-[#D4A03D]" />
            <span className="text-sm">{t.footer.location}</span>
          </div>
          <p className="text-sm text-white/50">{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
